"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OwnersGridSortProvider = exports.OwnersDefaultDirections = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
exports.OwnersDefaultDirections = {
    [catalog_queries_1.TableauUserOrderField.ID]: catalog_queries_1.OrderDirection.ASC,
    [catalog_queries_1.TableauUserOrderField.NAME]: catalog_queries_1.OrderDirection.ASC,
};
function OwnersGridSortProvider(props) {
    const { areUsersVisible } = (0, catalog_core_1.useUserSiteSettings)();
    const ownersDefaultSortField = areUsersVisible ? catalog_queries_1.TableauUserOrderField.NAME : catalog_queries_1.TableauUserOrderField.ID;
    const _a = exports.OwnersDefaultDirections, _b = catalog_queries_1.TableauUserOrderField.NAME, _ = _a[_b], validFieldsForHiddenUser = tslib_1.__rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
    const validFields = areUsersVisible
        ? exports.OwnersDefaultDirections
        : validFieldsForHiddenUser;
    return (react_1.default.createElement(data_catalog_shared_1.UrlSortProvider, { validOrderFieldsWithDefaultDirections: validFields, defaultField: ownersDefaultSortField }, props.children));
}
exports.OwnersGridSortProvider = OwnersGridSortProvider;
//# sourceMappingURL=OwnersGridSortProvider.js.map